import React from 'react';
import { Link } from 'react-router-dom';

export default function ConditionsPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa', paddingTop: '100px', paddingBottom: '4rem' }}>
      <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '0 1.5rem' }}>
        <div style={{ background: 'white', borderRadius: '16px', padding: '3rem', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', color: 'var(--blue-dark)', marginBottom: '0.5rem' }}>
            CONDITIONS D'UTILISATION
          </h1>
          <p style={{ color: 'var(--gray-text)', fontSize: '0.85rem', marginBottom: '2.5rem' }}>
            Dernière mise à jour : Mars 2026
          </p>

          <Section title="1. Présentation de la plateforme">
            ELIM DEPANNAGE est une plateforme numérique qui met en relation des clients ayant besoin de services de dépannage automobile et moto avec des prestataires professionnels au Bénin. En utilisant notre plateforme, vous acceptez les présentes conditions d'utilisation.
          </Section>

          <Section title="2. Conditions d'inscription">
            <ul>
              <li>Vous devez être âgé d'au moins 18 ans.</li>
              <li>Vous devez résider au Bénin ou y exercer votre activité.</li>
              <li>Les informations fournies lors de l'inscription doivent être exactes et à jour.</li>
              <li>Un seul compte par personne est autorisé.</li>
              <li>Les prestataires doivent fournir un numéro CIP valide et une pièce d'identité.</li>
            </ul>
          </Section>

          <Section title="3. Règles d'utilisation">
            <ul>
              <li>Il est interdit de publier de fausses informations ou de faux avis.</li>
              <li>Tout comportement abusif, frauduleux ou malhonnête entraînera la suspension du compte.</li>
              <li>Les prestataires s'engagent à respecter les délais d'intervention convenus.</li>
              <li>Les clients s'engagent à payer les services rendus.</li>
              <li>Toute tentative de contournement de la plateforme pour éviter les frais est interdite.</li>
            </ul>
          </Section>

          <Section title="4. Responsabilités">
            ELIM DEPANNAGE agit en tant qu'intermédiaire entre clients et prestataires. Nous ne sommes pas responsables de la qualité des services rendus par les prestataires. Cependant, nous mettons tout en œuvre pour vérifier les prestataires inscrits sur notre plateforme (vérification du CIP, avis clients).
          </Section>

          <Section title="5. Paiements et remboursements">
            <ul>
              <li>Les paiements s'effectuent via Mobile Money (MTN, Moov, Celtiis).</li>
              <li>En cas de litige, le client peut ouvrir un recours dans les 48h suivant la prestation.</li>
              <li>Les remboursements sont traités sous 3 à 5 jours ouvrables.</li>
              <li>ELIM DEPANNAGE perçoit une commission sur chaque transaction réalisée via la plateforme.</li>
            </ul>
          </Section>

          <Section title="6. Suspension et suppression de compte">
            Nous nous réservons le droit de suspendre ou supprimer tout compte en cas de violation des présentes conditions, de comportement frauduleux, ou de plaintes répétées de la part d'autres utilisateurs.
          </Section>

          <Section title="7. Modification des conditions">
            ELIM DEPANNAGE se réserve le droit de modifier ces conditions à tout moment. Les utilisateurs seront informés par email de tout changement majeur.
          </Section>

          <Section title="8. Contact">
            Pour toute question relative aux présentes conditions, contactez-nous à : <a href="mailto:elimdepannage@gmail.com" style={{ color: 'var(--orange)' }}>elimdepannage@gmail.com</a>
          </Section>

          <div style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid var(--gray-mid)' }}>
            <Link to="/" style={{ color: 'var(--orange)', fontWeight: 600 }}>← Retour à l'accueil</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '2rem' }}>
      <h2 style={{ fontFamily: 'var(--font-cond)', fontSize: '1.1rem', color: 'var(--blue-dark)', marginBottom: '0.8rem', textTransform: 'uppercase', letterSpacing: '1px' }}>{title}</h2>
      <div style={{ color: '#444', lineHeight: 1.8, fontSize: '0.95rem' }}>{children}</div>
    </div>
  );
}
